<script lang="ts">
    import Manager from "../application/models/Manager.ts";
    import {Icon, Tooltip, Modal} from "svelma";
    import CardPackModal from "./modals/CardPackModal.svelte";
    import {createEventDispatcher} from "svelte";
    import {_} from 'svelte-i18n';

    export let cards: Array<any>;
    export let manager: Manager;
    export let onMobile: boolean;

    let calcTime = manager.dateManager.calculateTimeFromBlockNumber;

    const dispatch = createEventDispatcher();

    function modalOpen(event){
        dispatch('modalOpen',{
            type: 'cardPack',
            data: cards
        });
    }
</script>

<div class="card scale" class:pos={!onMobile} class:mobileMargin={onMobile}>
    <div class="has-background-primary has-text-white has-text-weight-bold">
        {calcTime(cards[0].startBlock)}
    </div>
    <div class="columns is-gapless plate" on:click={modalOpen}>
        <div class="column has-text-info-dark lineH">
            {$_('cardPack.subjects')}: {cards.length}
        </div>
        <div class="column has-text-primary-dark opacity is-one-third info is-hidden-mobile">
            <Tooltip label="{$_('cardPack.details')}">
                <Icon pack="fa" size="is-medium" icon="info-circle"/>
            </Tooltip>
        </div>
    </div>
</div>

<style>
    .mobileMargin{
        margin: 20px 0 20px 0;
    }

    .opacity{opacity: 0.3;}

    .lineH{line-height: 35px}

    .plate:hover{
        cursor: pointer;
    }

    .plate:hover > .info{
        opacity: 1!important;
        cursor: pointer;
    }

    .scale {
        min-width: 100%;
        max-width: 100%;
        height: 60px;
        z-index: 10;
    }

    .pos {
        position: absolute;
        top: 0;
        left: 0;
    }

    @media screen and (max-width: 1100px){
        .plate {
            font-size: 12px!important;
        }
    }
</style>